import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from "../store/hooks";
import Logo from "../statics/logo/logo-purls.svg";
import { logOut } from '../store/user';

export default function ErrorPage({ }) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const reinstall = () => {
    dispatch(logOut())
    navigate('/')
    window.location.reload()
  }

  const reloadPage = () => {
    window.location.reload()
  }
  return (<>
    <div className='errorPageContainer'>
      <img src={Logo} alt="PURLs logo" />
      <h2>Oops something went wrong.</h2>
      <div>
        <p>
          It seems that there has been a problem with the load of the page,
          to solve it please use this buttons:
        </p>
      </div>
      <div className="buttons">
        <button onClick={reloadPage}>RELOAD PAGE</button>
        <button onClick={reinstall}>RE INSTALL APP</button>
      </div>
      <div>
        If the problem still persists please contact us by email:
        support@confiepurls.com
      </div>
    </div>
  </>)
}